export default __webpack_public_path__ + "static/media/vector1.558be214.png";